<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <FormItem label="姓名" prop="name">
        <Input v-model="form.name" placeholder="请输入姓名" style="width: 440px"></Input>
      </FormItem>
      <FormItem label="手机号" prop="mobile">
        <Input v-model="form.mobile" placeholder="请输入手机号" style="width: 440px"></Input>
      </FormItem>
      <FormItem label="邮箱" prop="email">
        <Input v-model="form.email" placeholder="请输入邮箱" style="width: 440px"></Input>
      </FormItem>
      <FormItem label="状态" prop="status">
        <RadioGroup v-model="form.status">
          <Radio label="1">启用</Radio>
          <Radio label="0">冻结</Radio>
        </RadioGroup>
      </FormItem>
      <FormItem label="密码" prop="password" :class="[query.id ? '' : 'ivu-form-item-required']">
        <Input
          :readonly="isReadOnly"
          @on-focus="changeType"
          v-model="form.password"
          placeholder="请输入密码"
          type="password"
          style="width: 440px"
        ></Input>
      </FormItem>
      <FormItem label="确认密码" prop="password_confirmation" :class="[query.id ? '' : 'ivu-form-item-required']">
        <Input
          :readonly="isReadOnly"
          @on-focus="changeType"
          v-model="form.password_confirmation"
          placeholder="请输入确认密码"
          type="password"
          style="width: 440px"
        ></Input>
      </FormItem>
      <FormItem label="所属角色" prop="roles">
        <div>
          角色不够？
          <a @click="$router.push({ name: 'role-manage' })">新建角色</a>
        </div>
        <Row>
          <Col span="6" v-for="(item, index) in apiData.roleList" :key="index">
            <Card class="card" :class="[form.roles.includes(item.id) ? 'card-active' : '']">
              <div @click="chooseRole(item)" style="text-align: center">
                <h3>{{ item.name }}</h3>
                <Tag color="primary">自定义</Tag>
              </div>
            </Card>
          </Col>
        </Row>
      </FormItem>
      <FormItem label="功能权限" prop="permission">
        <div class="permission-wrap">
          <Alert show-icon>决定用户可以看到哪些页面和哪些操作</Alert>
          <div class="permission-content">
            <div class="item" v-for="(item, index) in apiData.permissionList" :key="index">
              <Tree :ref="`ref${index}`" :data="[item]" show-checkbox></Tree>
            </div>
          </div>
        </div>
      </FormItem>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
    <Button style="width: 90px" @click="$router.go(-1)">取消</Button>
  </div>
</template>

<script>
  import * as apiStaff from '@/api/permission/admin'
  export default {
    name: 'add-form',
    data() {
      return {
        // 解决表单自动填充
        isReadOnly: true,
        query: {},
        search: {},
        diyDom: {},
        // 表单数据
        form: {
          name: '',
          mobile: '',
          email: '',
          status: '1',
          permission: [], // 权限id
          roles: [], // 角色id
          password: '',
          password_confirmation: '',
        },
        diyData: {
          rules: {
            name: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
            mobile: [{ required: true, message: '请输入手机号', trigger: 'blur' }],
            email: [{ required: true, message: '邮箱不能为空', trigger: 'blur' }],
            status: [{ required: true, message: '请选择状态', trigger: 'change' }],
            permission: [{ required: true, type: 'array', message: '请选择权限', trigger: 'change' }],
            roles: [{ required: true, type: 'array', message: '请选择角色', trigger: 'change' }],
          },
          permissionArr: [], // 反查询菜单
        },
        apiData: {
          roleList: [], // 角色列表
          permissionList: [], // 权限列表
          noroleId: [], // 详情带出，不在详情属于角色的权限id
        },
      }
    },
    methods: {
      // 获取详情
      getDetail() {
        apiStaff.apiAdminUserDetail(this.query.id).then(res => {
          this.form.name = res.data.name
          this.form.mobile = res.data.mobile
          this.form.email = res.data.email
          this.form.status = res.data.status + ''
          this.form.password = res.data.password
          this.form.permission = res.data.permission
          this.form.roles = res.data.roles.map(item => item.id)
          // 获取属于角色权限id
          let rolesId = this.getAllRoleId(this.form.roles)
          // 获取不属于角色权限id
          this.apiData.noroleId = this.getIdNoRole(rolesId, this.form.permission)
          // 回填树
          this.selectAuth(this.form.permission, this.apiData.permissionList)
        })
      },
      // 获取选择的角色的里面的id
      getAllRoleId(role) {
        let ids = []
        this.apiData.roleList.forEach(item => {
          if (role.includes(item.id)) {
            item.permission_id.forEach(citem => {
              ids.push(citem)
            })
          }
        })
        return ids
      },
      // 获取不是角色里面的id
      getIdNoRole(role, permission) {
        let arr1 = role.filter(item => !permission.includes(item))
        let arr2 = permission.filter(item => !role.includes(item))
        return arr1.concat(arr2)
      },
      // 回填树选中项
      selectAuth(menus, arr) {
        arr.forEach((item, index) => {
          if (menus.includes(item.id)) {
            this.$set(arr[index], 'checked', true)
            // 如果不是角色中包含的权限，不禁用
            if (this.getAllRoleId(this.form.roles).includes(item.id)) {
              this.$set(arr[index], 'disabled', true)
            }
          } else {
            this.$set(arr[index], 'checked', false)
            this.$set(arr[index], 'disabled', false)
          }
          if (item.children && item.children.length > 0) {
            this.$set(arr[index], 'checked', false)
            this.selectAuth(menus, item.children)
          }
        })
      },
      // 解决自动填充表单
      changeType() {
        this.isReadOnly = false
      },
      // 获取列表数据
      getTableList() {
        this.$store.commit('setSpinShow', true)
        apiStaff
          .apiAdminUserList()
          .then(res => {
            const { meta } = res
            this.apiData.roleList = meta.roles
            this.query.id && this.getDetail()
          })
          .finally(() => this.$store.commit('setSpinShow', false))
      },

      // 获取所有的权限
      getPermission() {
        apiStaff.apiGetPermission().then(res => {
          this.apiData.permissionList = res.data.map(item => {
            return {
              ...item,
              value: [],
            }
          })
          this.getTableList()
        })
      },

      // 选择角色
      chooseRole(item) {
        if (this.form.roles.includes(item.id)) {
          this.form.roles = this.form.roles.filter(v => v != item.id)
        } else {
          this.form.roles.push(item.id)
        }
        // 通过获取到的角色，然后重新设置权限树
        let permission = []
        this.apiData.roleList.forEach(citem => {
          if (this.form.roles.includes(citem.id)) {
            permission = [...permission, ...citem.permission_id]
          }
        })
        // 选择角色重设的时候，不是角色内的不做处理，仍要回填
        permission = [...permission, ...this.apiData.noroleId]
        // 去重
        permission = [...new Set(permission)]
        if (permission.length > 0) {
          // 回填树
          this.selectAuth(permission, this.apiData.permissionList)
        }
      },

      submit() {
        // 获取树id权限集合
        this.form.permission = []
        this.apiData.permissionList.forEach((item, index) => {
          this.$refs[`ref${index}`][0].getCheckedNodes().forEach(citem => {
            this.form.permission.push(citem.id)
          })
        })
        // 数组去重
        this.form.permission = [...new Set([...this.form.permission, ...this.form.permission])].sort()
        this.$refs['addForm'].validate(valid => {
          if (valid) {
            const opt = { ...this.form }
            this.$store.commit('setSpinShow', true)
            if (this.query.id) {
              if (this.form.password_confirmation == '' && this.form.password == '') {
                delete opt.password_confirmation
                delete opt.password
              }
              apiStaff
                .apiAdminUserEdit(this.query.id, opt)
                .then(res => {
                  this.$Message.success('编辑成功')
                  this.$router.replace({
                    name: 'admin-manage',
                  })
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            } else {
              apiStaff
                .apiAdminUserAdd(opt)
                .then(res => {
                  this.$Message.success('新增成功')
                  this.$router.replace({
                    name: 'admin-manage',
                  })
                })
                .finally(() => this.$store.commit('setSpinShow', false))
            }
          }
        })
      },
    },
    mounted() {
      this.query = this.$route.query
      this.getPermission()
    },
  }
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
    .card {
      width: 95%;
      margin-top: 10px;
      cursor: pointer;
    }
    .card-active {
      background: #2d8cf0;
      color: #fff;
    }
    .permission-wrap {
      padding: 10px 20px;
      border: 1px solid #ededed;
      .permission-content {
        display: flex;
        .item {
          width: 25%;
        }
      }
    }
  }
</style>
